module.exports = __webpack_public_path__ + "img/link05.250f3a3e.png";